module.exports = __webpack_public_path__ + "media/images/landing/ar/main-1ed4a8e6bebf03cc03fce7d9d0431fef.webp";